export default __webpack_public_path__ + "static/media/yousuf.f0dfaa12.webp";